import type { SVGProps } from 'react';

const SvgArrowUpBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M12 4L12 20' stroke='currentColor' strokeWidth={2} strokeMiterlimit={10} strokeLinecap='round' />
    <path d='M18 10L12 4L6 10' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgArrowUpBd;
